import { render, staticRenderFns } from "./teacherOff.vue?vue&type=template&id=55a6ebc9&scoped=true"
import script from "./teacherOff.vue?vue&type=script&lang=js"
export * from "./teacherOff.vue?vue&type=script&lang=js"
import style0 from "./teacherOff.vue?vue&type=style&index=0&id=55a6ebc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a6ebc9",
  null
  
)

export default component.exports